import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
// import {Auth} from 'aws-amplify'

import VueRouter from 'vue-router'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'


import store from './store'
import router from './router'
import config from './config'


// console.log(config.cognito.aws_cognito_region)
// console.log(config.cognito.aws_user_pools_id)
// console.log(config.cognito.aws_cognito_identity_pool_id)
// console.log(config.cognito.aws_user_pools_web_client_id)
Amplify.configure({
    Auth: {
      mandatorySignIn: false,
      region: config.cognito.aws_cognito_region,
      userPoolId: config.cognito.aws_user_pools_id,
      // identityPoolId: config.cognito.aws_cognito_identity_pool_id,
      userPoolWebClientId: config.cognito.aws_user_pools_web_client_id
    },
    API: {
        endpoints: [
            {
                name: "cmdb",
                endpoint: config.apiGatewayCmdb.URL,
              //   custom_header: async () => { 
              //     // return { Authorization : 'token' } 
              //     // Alternatively, with Cognito User Pools use this:
              //     return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
              //   },
              // region: config.apiGatewayCmdb.REGION
            },
            {
                name: "ipman",
                endpoint: config.apiGatewayIPMan.URL,
            //   custom_header: async () => { 
            //     // return { Authorization : 'token' } 
            //     // Alternatively, with Cognito User Pools use this:
            //     //return { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
            //   }
              region: config.apiGatewayIPMan.REGION
            },
        ]
    }
});


Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
